import { Trash2, ShoppingBag } from "lucide-react";

export const Cart = ({ items, name, phone, onNameChange, onPhoneChange, onRemove, onCheckout, submitting }) => {
  const total = items.reduce((sum, i) => sum + i.price, 0);
  const canCheckout = items.length > 0 && name.trim().length > 1 && phone.trim().length >= 8;

  return (
    <aside
      data-testid="cart-panel"
      className="w-full lg:w-[270px] xl:w-[340px] lg:shrink-0 bg-white border-t-2 lg:border-t-0 lg:border-l-2 border-slate-200 flex flex-col lg:h-full"
    >
      {/* Header */}
      <div className="px-4 sm:px-6 py-4 sm:py-5 border-b-2 border-slate-200 flex items-center gap-3 shrink-0">
        <ShoppingBag size={22} className="text-slate-900 shrink-0" strokeWidth={2.5} />
        <h2 className="font-display text-xl sm:text-2xl font-bold text-slate-900">Din bestilling</h2>
      </div>

      {/* Items */}
      <div className="lg:flex-1 lg:overflow-y-auto hide-scrollbar px-4 sm:px-6 py-4 max-h-60 overflow-y-auto lg:max-h-none">
        {items.length === 0 ? (
          <p data-testid="cart-empty" className="text-center text-slate-400 font-semibold py-4 lg:mt-8 text-sm sm:text-base">
            Ingen varer endnu.<br />Vælg en trøje ovenfor.
          </p>
        ) : (
          <ul className="space-y-2 sm:space-y-3">
            {items.map((item, idx) => (
              <li
                key={idx}
                data-testid={`cart-item-${idx}`}
                className="flex items-center gap-2 sm:gap-3 bg-slate-50 rounded-xl p-2.5 sm:p-3"
              >
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-slate-900 truncate text-sm sm:text-base">
                    {item.product_name}
                  </div>
                  <div className="text-xs sm:text-sm text-slate-500 font-semibold truncate">
                    {item.size} · {item.color_label}
                  </div>
                </div>
                <div className="font-display font-bold text-slate-900 whitespace-nowrap text-sm sm:text-base">
                  {item.price} kr
                </div>
                <button
                  data-testid={`remove-item-${idx}`}
                  onClick={() => onRemove(idx)}
                  className="text-slate-400 hover:text-red-500 active:scale-90 transition-all p-1 shrink-0"
                  aria-label="Fjern"
                >
                  <Trash2 size={18} />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Customer info + checkout */}
      <div className="px-4 sm:px-6 py-4 sm:py-5 pb-16 sm:pb-20 lg:pb-16 border-t-2 border-slate-200 shrink-0 space-y-3">
        <input
          data-testid="input-name"
          type="text"
          placeholder="Navn"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          className="h-12 w-full px-4 rounded-xl border-2 border-slate-200 bg-slate-50 text-base font-semibold focus:border-slate-900 outline-none min-w-0"
        />
        <input
          data-testid="input-phone"
          type="tel"
          inputMode="numeric"
          placeholder="Telefonnummer"
          maxLength={8}
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value.replace(/[^0-9]/g, "").slice(0, 8))}
          className="h-12 w-full px-4 rounded-xl border-2 border-slate-200 bg-slate-50 text-base font-semibold focus:border-slate-900 outline-none min-w-0"
        />

        <div className="flex items-center justify-between pt-2">
          <span className="text-slate-500 font-bold">I alt</span>
          <span data-testid="cart-total" className="font-display text-2xl sm:text-3xl font-bold text-slate-900">
            {total} kr
          </span>
        </div>

        <button
          data-testid="btn-checkout"
          onClick={onCheckout}
          disabled={!canCheckout || submitting}
          className={`h-14 sm:h-16 w-full rounded-2xl font-display text-lg sm:text-xl font-bold flex items-center justify-center transition-all ${
            canCheckout && !submitting
              ? "bg-[#5A78FF] text-white active:scale-95 hover:bg-[#4a68ee] shadow-md"
              : "bg-slate-200 text-slate-400 cursor-not-allowed"
          }`}
        >
          {submitting ? "Sender..." : "Betal med MobilePay"}
        </button>
      </div>
    </aside>
  );
};
